import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, List, ListItem, Stack } from '@mui/joy';
import './BillOverview.css';

function BillOverview({ bill }) {
  const readText = () => {
    window.open(bill?.text, '_blank');
  };

  return (
    <Stack direction={"column"} spacing={4} padding={4}>
      <Stack direction={"column"} spacing={0} sx={{alignItems: 'flex-start'}}>
        <Typography level="title-sm"> {bill?.category} </Typography>
        <Typography level="h1"> {bill?.title} </Typography>
        <Typography level="title-lg"> {bill?.fullTitle} </Typography>
        <Typography level="body-md" sx={{ marginTop: 2 }}>
          {' '}
          {bill?.description}{' '}
        </Typography>
        {bill?.text ? (
          <Button
            variant="soft"
            color="primary"
            sx={{ marginTop: 3 }}
            onClick={readText}
          >
            Read the full document
          </Button>
        ) : null}
      </Stack>

      <Box sx={{paddingTop: '96px'}}>
        <Typography level="h2">Who it affects</Typography>
        <List marker="circle">
          {bill?.whoItAffects.length > 0
            ? bill?.whoItAffects.map((group, index) => (
                <ListItem key={index}>
                  <Typography level="body-lg">{group}</Typography>
                </ListItem>
              ))
            : null}
        </List>
      </Box>
      <Box>
        <Typography level="h2"> Why it matters </Typography>
        <Typography level="body-lg" sx={{ marginTop: 2 }}>
          {bill?.whyItMatters}
        </Typography>
      </Box>
      <Box>
        <Typography level="h2"> What supporters say </Typography>
        <Typography level="body-lg" sx={{ marginTop: 2 }}>
          {bill?.support}
        </Typography>
      </Box>
      <Box sx={{paddingBottom: '40px'}}>
        <Typography level="h2"> What the opposition says </Typography>
        <Typography level="body-lg" sx={{ marginTop: 2 }}>
          {bill?.opposition}
        </Typography>
      </Box>
    </Stack>
  );
}

// Prop types for our Component
BillOverview.propTypes = {
  bill: PropTypes.object.isRequired,
};

export default BillOverview;
